/**
 * @flow
 * @author: Manikanta
 */

import React, { Component } from 'react'
import PropTypes from 'prop-types'
import Colors from '../../../themes/Colors'
import {
  InputContainer,
  MainContainer,
  CustomInput,
  ErrorText,
  IconView,
  LabelText,
  IconContainer
} from './styledComponents'

class Input extends Component<Props> {
  constructor(props) {
    super(props)
    this.state = {
      value: '',
      errorMsg: '',
      displayError: false,
      isFocused: false
    }
  }

  setError = error => {
    this.setState({ errorMsg: error })
  }
  setDisplayError = displayError => {
    this.setState({ displayError })
  }

  validate = () => {
    const { validationEnabled, validate } = this.props
    let response
    if (validationEnabled) {
      if (validate) {
        response = validate(this.state.value)
        if (response.displayError) {
          this.setError(response.errorMsg)
        }
        this.setDisplayError(response.displayError)
      }
    }
    return response
  }
  reset = () => {
    this.setState({
      value: '',
      errorMsg: '',
      displayError: false,
      isFocused: false
    })
  }

  onFocusInput = () => {
    this.setState({
      isFocused: true,
      displayError: false,
      errorMsg: ''
    })
    const { onFocus } = this.props
    if (onFocus) {
      onFocus()
    }
  }

  onBlurInput = () => {
    this.setState({
      isFocused: false
    })
    this.validate()
    const { onBlur } = this.props
    if (onBlur) {
      onBlur()
    }
  }

  onChangeInput = e => {
    const { value } = e.target
    this.setState({
      value,
      errorMsg: '',
      displayError: false
    })
  }

  getUserIcon = () => {
    const { isFocused } = this.state
    const { icon: Icon, iconStyle } = this.props
    let strokeColor = Colors.blueyGreyThree
    if (isFocused) {
      strokeColor = Colors.twilightBlueTwo
    }

    return (
      <IconContainer style={iconStyle}>
        <Icon strokeColor={strokeColor} />
      </IconContainer>
    )
  }

  render() {
    const { value, errorMsg, displayError, isFocused } = this.state
    const {
      label,
      className,
      icon: Icon,
      isMobile,
      id,
      isBhowaniporePresentInQueryParams,
      ...other
    } = this.props
    return (
      <InputContainer
        {...other}
        isBhowaniporePresentInQueryParams={isBhowaniporePresentInQueryParams}
        id={id}
      >
        {label && (
          <LabelText
            id="input_label"
            displayError={displayError}
            isMobile={isMobile}
          >
            {label}
          </LabelText>
        )}
        <MainContainer
          isMobile={isMobile}
          isFocused={isFocused}
          className={className}
          displayError={displayError}
          value={value}
          isBhowaniporePresentInQueryParams={isBhowaniporePresentInQueryParams}
        >
          <IconView>{this.getUserIcon()}</IconView>
          <CustomInput
            {...other}
            value={value}
            isFocused={isFocused}
            onFocus={this.onFocusInput}
            onBlur={this.onBlurInput}
            onChange={this.onChangeInput}
          />
        </MainContainer>
        <ErrorText id={`${id}-error-message`}>{errorMsg}</ErrorText>
      </InputContainer>
    )
  }
}

Input.propTypes = {
  isMobile: PropTypes.bool,
  validationEnabled: PropTypes.bool,
  label: PropTypes.string,
  className: PropTypes.string,
  icon: PropTypes.node.isRequired,
  validate: PropTypes.func,
  placeholder: PropTypes.string,
  iconStyle: PropTypes.object
}

Input.defaultProps = {
  isMobile: false,
  validationEnabled: true,
  placeholder: '',
  label: ''
}

export default Input



// WEBPACK FOOTER //
// ./src/components/FormHomePage/Input/index.js